/* eslint-disable no-case-declarations */
import { Reducer } from 'redux';
// import _ from 'lodash';

import { Action, ActionType } from '../actionTypes/budgetCostActionTypes';
import { IBudgetCost as BudgetCost, IBudgetCostReport } from '../../models/budgetCost';

export interface IBudgetCostsState {
    budgetCosts: BudgetCost[];
    budgetCostsReport: IBudgetCostReport[];
    loading: boolean;
    error: string | null,
}
const initialState = {
    budgetCosts: [],
    budgetCostsReport: [],
    loading: false,
    error: null,   
};
export const BudgetCostReducer: Reducer<IBudgetCostsState, Action> = (
    state = initialState,
    action
) => {
    switch (action.type) {
        case ActionType.FETCH_BUDGETCOSTS:
        case ActionType.FETCH_BUDGETCOSTSREPORT:
        case ActionType.ADD_BUDGETCOST:
        case ActionType.EDIT_BUDGETCOST:
        case ActionType.DELETE_BUDGETCOST:
            return { ...state, loading: true };

        case ActionType.FETCH_BUDGETCOSTS_FAIL:
        case ActionType.FETCH_BUDGETCOSTSREPORT_FAIL:
        case ActionType.ADD_BUDGETCOST_FAIL:
        case ActionType.EDIT_BUDGETCOST_FAIL:
        case ActionType.DELETE_BUDGETCOST_FAIL:
            return { 
                ...state, 
                loading: false,
                error: action.payload
            };

        case ActionType.ADD_BUDGETCOST_SUCCESS:
            // console.log("action.payload: ", action.payload)
            return {
                ...state,
                budgetCosts: [ ...state.budgetCosts, action.payload ],
                loading: false
            };

        case ActionType.FETCH_BUDGETCOSTS_SUCCESS:
            return {
                ...state,
                budgetCosts: action.payload.data,
                loading: false
            };

        case ActionType.FETCH_BUDGETCOSTSREPORT_SUCCESS:
            return {
                ...state,
                budgetCostsReport: action.payload.data,
                loading: false
            };

        case ActionType.EDIT_BUDGETCOST_SUCCESS:
            const budgetCost: BudgetCost = action.payload
            const index = state.budgetCosts.findIndex(itm => Number(itm.budgetcostid) === Number(budgetCost.budgetcostid))
            const budgetCostsPart1 = state.budgetCosts.slice(0, index)
            const budgetCostsPart2 = state.budgetCosts.slice(index + 1)
            return {
                ...state,
                budgetCosts: [ ...budgetCostsPart1, budgetCost, ...budgetCostsPart2 ],
                loading: false
            };
        case ActionType.DELETE_BUDGETCOST_SUCCESS:
            return {
                ...state,
                budgetCosts: state.budgetCosts.filter(budgetCost => budgetCost.budgetcostid !== action.payload),
            };

        default:

            return state;
    }
};
